import { InfoSecurity } from "./screens/InfoSecurity";
import { PhoneNumber } from "./screens/PhoneNumber";
import { ConfirmToken } from "./screens/ConfirmToken";
import { BiometryValidation } from "./screens/BiometryValidation";
import { SelectProduct } from "./screens/SelectProduct";
import { FinancialService } from "./screens/FinancialService";
import { ServicePoint } from "./screens/ServicePoint";
import { SelectAttendant } from "./screens/SelectAttendant";
import { VerifyInformations } from "./screens/VerifyInformations";
import { SelectDocuments } from "./screens/SelectDocuments";
import { CaptureDocument } from "@repo/core/screens/PreProposal/screens/CaptureDocument";

// eslint-disable-next-line react-refresh/only-export-components
export const PreProposalScreens = {
  InfoInfoSecurity: InfoSecurity,
  PhoneNumber: PhoneNumber,
  ConfirmToken: ConfirmToken,
  BiometryValidation: BiometryValidation,
  SelectProduct: SelectProduct,
  FinancialService: FinancialService,
  ServicePoint: ServicePoint,
  SelectAttendant: SelectAttendant,
  VerifyInformations: VerifyInformations,
  SelectDocuments: SelectDocuments,
  CaptureDocument: CaptureDocument
};

export default PreProposalScreens;
